var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.workingClass},[_c('i',{staticClass:"material-icons",staticStyle:{"float":"left"}},[_vm._v(_vm._s(_vm.icon))]),_vm._v(" "),(!_vm.isMobileDevice())?_c('span',{staticStyle:{"float":"right"}},[_vm._v(_vm._s(_vm.text))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }